import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e64ede0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "MapSearch" }
const _hoisted_2 = { class: "MapSearch__wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "wrapper__city"
}
const _hoisted_4 = {
  key: 0,
  class: "MapSearch__results"
}
const _hoisted_5 = {
  key: 0,
  class: "results__loading"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader large green" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "result__title" }
const _hoisted_10 = { class: "result__description" }
const _hoisted_11 = {
  key: 1,
  class: "results__empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.city)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.city.name), 1))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchState.query) = $event)),
        placeholder: "Адрес или объект",
        class: "MapSearch__input",
        onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
      }, null, 544), [
        [_vModelText, _ctx.searchState.query]
      ])
    ]),
    (_ctx.searchState.last_query)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.searchState.state.is_loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.searchState.results.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.searchState.results, (result, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "results__result",
                        key: `search-result-${i}`,
                        onClick: ($event: any) => (_ctx.selectResult(result))
                      }, [
                        _createElementVNode("p", _hoisted_9, _toDisplayString(result.name), 1),
                        _createElementVNode("p", _hoisted_10, _toDisplayString(result.description), 1)
                      ], 8, _hoisted_8))
                    }), 128))
                  : (_openBlock(), _createElementBlock("div", _hoisted_11, " По запросу \"" + _toDisplayString(_ctx.searchState.last_query) + "\" ничего не найдено ", 1))
              ], 64))
        ]))
      : _createCommentVNode("", true)
  ]))
}